import {Amplify} from 'aws-amplify';

import {stage} from '../config/stage';

// get config
import {config} from '../config/amplify';
import {ConsoleLogger} from 'aws-amplify/utils';

Amplify.configure(config);

ConsoleLogger.LOG_LEVEL = stage === 'ide' ? 'DEBUG' : 'INFO';

(window as Window & { LOG_LEVEL?: string }).LOG_LEVEL = 'DEBUG';
